import { createFeatureSelector } from '@ngrx/store';

import { CORE_FEATURE_KEY, CoreModuleState } from '../reducers';

export const selectCoreModule = createFeatureSelector<CoreModuleState>(CORE_FEATURE_KEY);
